import {ModalProps} from "react-bootstrap/Modal";
import {Button, Modal} from "react-bootstrap";
import React, {FC, memo, useCallback, useEffect, useState} from "react";

import {Upload} from "react-bootstrap-icons";
import {Trash3} from "react-bootstrap-icons";
import {IFrame, IMedia} from "../../store/sliceModal";
import {fetchDeleteFile, fetchUploadFile} from "../../fetch/FileRequest";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store/configureStore";
import {actions} from "../../store/sliceModal";
import {config} from "../../config";
import DocViewer, {DocViewerRenderers} from "@cyntler/react-doc-viewer";

const ModalIframe:FC<ModalProps & IFrame> = (props) => {
    const {file, publicPath } = props
    const dispatch = useDispatch<AppDispatch>();

    const txt = ['txt', 'json', 'log', 'conf', 'js', 'html', 'ts', 'tsx', 'xml', 'css'];


    const format = (type: string): string => {
        if (txt.includes(type)) {
            return 'txt';
        }
        return type;
    }

    const deleteHandle = useCallback( (event: React.MouseEvent<HTMLButtonElement>) => {
        fetchDeleteFile(file?.id!, false).then(resp => {
            if (resp.status && resp.status < 400) {
                dispatch(actions.closeMediaModal())
            }
        })
    },[file?.id])

    const downloadHandle = useCallback( (event: React.MouseEvent<HTMLButtonElement>) => {
        fetchUploadFile(file?.id!, props.name)
    },[file?.id])

    return (
        <Modal
            {...props}
            size={"lg"}
            fullscreen
            //    centered
        >
            <Modal.Header closeButton style={{gap: "10px"}}>
                <Button variant={"outline-success"} onClick={downloadHandle}>
                    <Upload style={{marginRight: "5px"}}/>
                    Загрузить
                </Button>
                <Button variant={"outline-danger"} onClick={deleteHandle}>
                    <Trash3 style={{marginRight: "5px"}}/>
                    Удалить</Button>
            </Modal.Header>
            {file?.id && <Modal.Body style={{justifyContent: "center", display: "flex"}}>
                { !publicPath && <DocViewer pluginRenderers={DocViewerRenderers}
                           documents={[{uri: `${config.baseurl}/api/media/${file.id}`, fileType: `${format(file.type)}`, fileName: `${file.name}`}]}/>}
                { publicPath && <DocViewer pluginRenderers={DocViewerRenderers}
                                            documents={[{uri: `${config.baseurl}/api/public/file/media/${publicPath}/${file.id}`, fileType: `${format(file.type)}`, fileName: `${file.name}`}]}/>}
            </Modal.Body>}
            <Modal.Footer style={{justifyContent: "center"}}>{`${file?.name}.${file?.type}`}</Modal.Footer>
        </Modal>
    )
        ;
}

export default memo(ModalIframe)
